/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_ProductStatusCodes {
    BeingProcessed = 10,
    Active = 20,
    DiscontinuedFromStock = 40,
    NoLongerStocked = 50,
}
